import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=58083688&scoped=true"
import script from "./HomeBanner.js?vue&type=script&lang=js&external"
export * from "./HomeBanner.js?vue&type=script&lang=js&external"
import style0 from "./HomeBanner.scss?vue&type=style&index=0&id=58083688&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58083688",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotBanner: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/Banner/Banner.vue').default,HotButton: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default})
